<script>
  import { Input } from '@sveltestrap/sveltestrap';

  import InputUnits from './input-units.svelte';
  import { parseBorderString } from './utils';

  const units = ['px', 'rem'];

  export let value;

  export let onChange = () => {};

  let color = '#000000';
  let style = 'solid';
  let unit = 'px';
  let width = 0;

  $: disabled = width === 0;

  $: {
    const newValue = `${width}${unit} ${style} ${color}`;

    if (newValue !== value) {
      onChange(newValue);
    }
  }

  // When `value` changes externally, parse it
  $: if (value) {
    const parts = parseBorderString(value);

    color = parts.color;
    style = parts.style;
    unit = parts.units;
    width = parts.width;
  }
</script>

<InputUnits min={0} size="sm" type="number" {units} bind:unit bind:value={width}>
  <Input
    {disabled}
    id="color-picker"
    type="color"
    bsSize="sm"
    style="max-width: 2.5rem; height: 2.5rem;"
    bind:value={color}
  />
</InputUnits>
